import type { Params } from 'react-router-dom';

/** Single source of console paths, so a section can move without hunting for links. */
export const ROUTES = {
	today: '/',
	conversations: '/conversations',
	quality: '/quality',
	routing: '/routing',
	tools: '/tools',
	knowledge: '/knowledge',
	costs: '/costs',
	lab: '/lab',
	labEvaluations: '/lab/evaluations',
	labJudges: '/lab/judges',
	health: '/health',
	healthModules: '/health/modules',
	glossary: '/glossary',
} as const;

export const judgePath = (id: string): string => `${ROUTES.labJudges}/${id}`;
export const modulePath = (name: string): string => `${ROUTES.healthModules}/${name}`;
export const conversationPath = (threadId: string): string => `${ROUTES.conversations}/${threadId}`;

/** Old paths kept working for bookmarks and shared links. */
export const LEGACY_REDIRECTS: ReadonlyArray<readonly [from: string, to: string]> = [
	['/judges', ROUTES.labJudges],
	['/evaluations', ROUTES.labEvaluations],
	['/reports', ROUTES.quality],
	['/modules', ROUTES.healthModules],
	['/dependencies', ROUTES.health],
	['/playground', ROUTES.lab],
];

export type LegacyParamRedirect = Readonly<{
	from: string;
	/** Builds the new path from the params matched on `from`. */
	to: (params: Readonly<Params<string>>) => string;
}>;

/** Old paths with params, kept working for bookmarks and shared links. */
export const LEGACY_PARAM_REDIRECTS: readonly LegacyParamRedirect[] = [
	{ from: '/judges/:id', to: (p) => judgePath(p.id ?? '') },
	{ from: '/modules/:moduleName', to: (p) => modulePath(p.moduleName ?? '') },
];
